/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { cpf, cnpj } from 'cpf-cnpj-validator';
import Vue, { PluginObject } from 'vue';

const isEmpty = (value: any) => {
    return value === undefined || value === null || value === '';
};

const rules = {
    required: (value: any) => !isEmpty(value) || 'Campo obrigatório',
    arrayRequired: (value: any) => !isEmpty(value) || value.length > 0 || 'Campo obrigatório',
    email: (value: string) => {
        const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return isEmpty(value) || pattern.test(value) || 'E-mail inválido';
    },
    url: (value: string) => {
        const pattern = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}/gm;
        return isEmpty(value) || pattern.test(value) || 'URL inválida';
    },
    minlength: (value: string, length: number) =>
        isEmpty(value) || value.length >= length || 'Limite mínimo de caracteres',
    maxlength: (value: string, length: number) =>
        isEmpty(value) || value.length <= length || 'Limite máximo de caracteres',
    cpf: (value: string) => isEmpty(value) || cpf.isValid(value) || 'CPF inválido',
    cnpj: (value: string) => isEmpty(value) || cnpj.isValid(value) || 'CNPJ inválido',
    phone: (value: string) =>
        isEmpty(value) || /^\d{10,11}$/.test(value.replace(/\D/g, '')) || 'Telefone inválido',
    year: (value: any) =>
        isEmpty(value) || new RegExp(/^(19|20)\d{2}/).test(value) || 'Ano inválido',
    fixedSizeNumber: (digits: any) => {
        return (value: any) => {
            //'^.{' + digits + ',6}$'
            const regex = '\\d{' + digits + '}';
            return isEmpty(value) || new RegExp(regex).test(value) || 'Número inválido';
        };
    },
    number: (value: any) => isEmpty(value) || /(^\d+$)/.test(value) || 'Número inválido',
    slug: (value: any, message: any) =>
        isEmpty(value) || /^[a-z0-9\-._]+$/.test(value) || message || 'Valor inválido',
    strongPassword: (value: any) => {
        let result = /[a-z]/.test(value) || 'Senha precisa conter caracteres minúsculos';

        if (result === true) {
            result = /[A-Z]/.test(value) || 'Senha precisa conter caracteres maiúsculos';
        }

        if (result === true) {
            result = /[0-9]/.test(value) || 'Senha precisa conter pelo menos um número';
        }

        if (result === true) {
            result = /\W|_/.test(value) || 'Senha precisa conter pelo menos um caracter especial';
        }

        if (result === true) {
            result = value.length >= 8 || 'Senha deve possuir pelo menos 8 caracteres';
        }

        return result;
    },

    fileSize: (size: any) => {
        return (file: any) => {
            const sizeMB = size * 1024 * 1024;
            return !file || file.size <= sizeMB || `Arquivo deve ser inferior a ${size} MB`;
        };
    },

    filesSize: (size: any) => {
        return (files: any) => {
            const sizeMB = size * 1024 * 1024;
            return (
                !files ||
                !files.length ||
                files.reduce((sum: any, file: any) => (sum += file.size), 0) <= sizeMB ||
                `Total de arquivo deve ser inferior a ${size} MB`
            );
        };
    }
};

const platform = {
    isMobile: () => {
        const platform = navigator.platform.toLowerCase();
        return /(android|webos|iphone|ipad|ipod|blackberry|windows phone)/.test(platform);
    }
};

const masks = {
    cpf: '###.###.###-##',
    cnpj: '##.###.###/####-##',
    zipCode: '#####-###',
    year: '####',
    number: '#',
    plate: 'AAA-#N##',
    phone: '(##) #####-####',
    mac: 'NN:NN:NN:NN:NN:NN'
};

class ValidationPlugin implements PluginObject<any> {
    install = (_Vue: typeof Vue, options?: any) => {
        _Vue.prototype.$rules = rules;
        _Vue.prototype.$masks = masks;
        _Vue.prototype.$platform = platform;
    };
}

const plugin = new ValidationPlugin();
Vue.use(plugin);
